import React from 'react';
import styled from 'styled-components';
import { TableCell as MuiTableCell, TableCellProps } from '@material-ui/core';

interface IProps extends TableCellProps {
    active?: boolean;
}

const BaseTableCell = ({ ...other }: IProps) => (
    <MuiTableCell component="div" {...other} />
);

export const TableCell = styled(BaseTableCell)`
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
`;
